module.exports = __webpack_public_path__ + "static/media/Maf_CDI.cea5276a.jpg";